export enum FieldName {
  UserName = 'UserName',
  Password = 'Password',
}
